<!--
    描述：按钮信息
    日期：2021/04/28
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>按钮列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="success"
                               size="small"
                               icon="el-icon-check"
                               v-if="roleBtns.includes('post_menu_btn_save')"
                               @click="saveClick()">保存</el-button>
                </div>
            </div>

            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content"
                         ref="content"
                         style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="tree"
                                 :height="tableObj.tableH"
                                 :data="tableObj.data"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { getBtnsByMenuId } from 'api/system/menuBtn.js'
import { saveOrUpdateRoleMenuBtn,getCheckedBtn } from 'api/system/sysGroupRoleMenuBtn.js'

import { selectBtnsByMenuId,saveMenuAndBtn } from 'api/system/sysPosition.js'
export default {
    name : '',
    components: {

    },
    data() {
        return {
            groupId : '',
            roleId : '',
            menuId : '',

            tableObj: {
                loading: false,
                tableH: 400,
                data: [],
            },
            defaultProps: {
                children: 'children',
                label: 'sname'
            },
            //默认选择信息
            treeDefaultCheckedKey: [],

        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.tableObj.tableH = this.$refs.content.offsetHeight
            }, 100)
        })
    },
    // 缓存页面进入时
        activated() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.tableObj.tableH = this.$refs.content.offsetHeight
            }, 100)
        })
    },
    computed: {
        ...mapState('app', { clientSize: state => state.clientSize }),
        ...mapState('menu', {
            roleBtns: state => state.roleBtns
        })
    },
    watch: {
        clientSize(val) {
            this.tableObj.tableH = this.$refs.content.offsetHeight
        }
    },
    created() {},
    methods: {
        init(obj){
            this.treeDefaultCheckedKey = []
            this.tableObj.data = []
            //赋值菜单信息
            this.postId = obj.postId
            this.menuId = obj.menuId

            if(this.menuId == '') return

            //查询按钮信息
            this.selectBtnsByMenuId()

            //this.getMenuBtnTableList()

            /*
            this.limitMenuBtnIdList = []
            //获取菜单按钮列表信息
            this.getLimitMenuBtns().then(val => {
                this.getMenuBtnTableList();
            });
            */

            //获取权限菜单数据
            //this.getCheckedBtn()
        },
        //获取菜单按钮列表信息
        selectBtnsByMenuId(){
            let that = this
            let param = {
                positionId : this.postId,
                menuId: this.menuId
            }
            selectBtnsByMenuId(param).then(res => {
                if (res.operationCode == 1) {
                    that.tableObj.data = res.data
                    this.treeDefaultCheckedKey =res.data.filter(item=> item.isChecked == true).map(item=> {return item.id})
                }
            })
        },

        //获取菜单按钮列表信息
        getMenuBtnTableList() {
            let that = this
            let param = {
                menuId: this.menuId
            }

            //that.treeDefaultCheckedKey = []
            getBtnsByMenuId(param).then(res => {
                if (res.operationCode == 1) {
                    //that.treeDefaultCheckedKey = res.data.checkBtnIdList.concat()
                    that.tableObj.data = res.data
                    /*
                    if(this.limitMenuBtnIdList.filter(id=> id== -1).length > 0) {
                        that.tableObj.tableData = data
                        return
                    }
                    that.tableObj.tableData = data.map(prop=>{
                        let disabled = typeof(that.limitMenuBtnIdList.find(BtnId=> {return BtnId==prop.id })) != 'undefined' ? false : true
                        return {...prop, disabled : disabled}
                    })
                    */
                }
            })
        },
        getCheckedBtn(){
            let that = this
            let param = {
                groupId : this.groupId,
                roleId: that.roleId,
                menuId: that.menuId,
            }
            getCheckedBtn(param).then(res=>{
                if (res.operationCode == 1) {
                    this.treeDefaultCheckedKey = res.data
                }
            })
        },
        saveClick(){
            let that = this
            if (that.postId == '') {
                that.$message({ message: '请选择岗位信息', type: 'warning' })
                return
            }
            if (that.menuId == '') {
                that.$message({ message: '请选择菜单信息', type: 'warning' })
                return
            }
            let idsSelection = this.$refs.tree.getCheckedKeys().concat()
            idsSelection = idsSelection.map(nodeId=>{
                let temp = that.tableObj.data.find(v=> v.id == nodeId)
                let obj = {
                    "id": temp.id,
                    "sname": temp.sname,
                    "isChecked": true
                }
                return obj
            })
            let param = {
                positionId: that.postId,
                menuId: that.menuId,
                btnList: idsSelection
            }
            saveMenuAndBtn(param).then(res => {
                if (res.operationCode == 1) {
                    that.$message({ message: '保存成功', type: 'success' })
                }
            })
        },
    }
}
</script>
<style lang="less">

</style>